import React, { useState, useEffect } from 'react';
import Option from './Option';
import { dariAlphabet } from './dariAlphabet';
import { dariWords } from './dariWords';

function QuestionSection({ currentWord, currentLetterIndex, onCorrectAnswer }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isCorrect, setIsCorrect] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    setSelectedOption(null);
    setIsCorrect(null);
  }, [currentLetterIndex]);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    const answer = currentLetterIndex === currentWord.length ? currentWord : currentWord[currentLetterIndex];
    if (option.dari === answer) {
      setIsCorrect(true);
      setTimeout(() => {
        if (typeof onCorrectAnswer === 'function') {
          onCorrectAnswer();
        }
      }, 500);
    } else {
      setIsCorrect(false);
    }
  };

  useEffect(() => {
    if (currentLetterIndex === currentWord.length) {
      const randomOptions = [];
      while (randomOptions.length < 3) {
        const randomIndex = Math.floor(Math.random() * dariWords.length);
        const randomWord = dariWords[randomIndex];
        if (randomWord.dari !== currentWord && !randomOptions.includes(randomWord)) {
          randomOptions.push(randomWord);
        }
      }
      const currentWordInfo = dariWords.find(item => item.dari === currentWord);
      setOptions([...randomOptions, currentWordInfo].sort(() => Math.random() - 0.5));
    } else {
      const currentLetter = currentWord[currentLetterIndex];
      const currentLetterInfo = dariAlphabet.find(item => item.dari === currentLetter);

      const randomOptions = [];
      while (randomOptions.length < 3) {
        const randomIndex = Math.floor(Math.random() * dariAlphabet.length);
        const randomLetter = dariAlphabet[randomIndex];
        if (randomLetter.dari !== currentLetter && !randomOptions.includes(randomLetter)) {
          randomOptions.push(randomLetter);
        }
      }
      setOptions([...randomOptions, currentLetterInfo].sort(() => Math.random() - 0.5));
    }
  }, [currentLetterIndex, currentWord]);

  const questionText = currentLetterIndex === currentWord.length
    ? <p>What is the meaning of this word?</p>
    : <p>What is the English name of letter #{currentLetterIndex + 1}</p>;

  const answered = selectedOption !== null;

  const stateFor = (option) => {
    if (!answered) return '';
    // Only the option the user actually clicked is marked — never auto-reveal the answer.
    if (option === selectedOption) return isCorrect ? 'correct' : 'incorrect';
    return '';
  };

  return (
    <div className='question-section'>
      {questionText}
      {options.map((option, index) => (
        <Option
          key={`${currentLetterIndex}-${index}`}
          label={option.english}
          state={stateFor(option)}
          onClick={() => handleOptionClick(option)}
        />
      ))}
    </div>
  );
}

export default QuestionSection;
